import {
    on,
    off,
} from './dom';

import {
    Config,
    getRouteChangeEventIsWrapped,
    setRouteChangeEventWrapped,
    ROUTE_MODE,
    getInnerEventName
} from './config';


const win = typeof window !== 'undefined' && window;
const doc = win && document;


/**
  * 路由监听
  *
  * @function
  * @param {Function} handler 路由切换的时候的回调函数
  */
const onRouteChange = handler => {
    // eslint-disable-next-line no-empty-function
    handler = typeof handler === 'function' ? handler : () => {};
    const observeHandler = (...args) => {
        handler(...args);
    };
    const restoreFns = [];
    if (Config.ROUTE_MODE !== ROUTE_MODE.SERVER) {
        if (Config.ROUTE_MODE === ROUTE_MODE.HASH) {
            on(win, 'hashchange', observeHandler);
            restoreFns.push(() => off(win, 'hashchange', observeHandler));
        }
        else {
            if (!getRouteChangeEventIsWrapped()) {
                const patchedUpdateState = (updateState, methodName) => {
                    setRouteChangeEventWrapped();

                    return (...args) => {
                        const returnValue = updateState.apply(history, args);

                        const event = doc.createEvent('Event');
                        event.initEvent(methodName.toLowerCase(), true, true);
                        event.habo = true;
                        event.haboTrigger = methodName;
                        event.arguments = args;
                        win.dispatchEvent(event);
                        return returnValue;

                    };
                };

                history.pushState = patchedUpdateState(win.history.pushState, getInnerEventName('pushstate'));
                history.replaceState = patchedUpdateState(win.history.replaceState, getInnerEventName('replacestate'));
            }

            on(win, 'popstate', observeHandler);
            on(win, getInnerEventName('pushstate'), observeHandler);
            on(win, getInnerEventName('replacestate'), observeHandler);

            restoreFns.push(() => off(win, 'popstate', observeHandler));
            restoreFns.push(() => off(win, getInnerEventName('pushstate'), observeHandler));
            restoreFns.push(() => off(win, getInnerEventName('replacestate'), observeHandler));
        }
    }

    const tearDown = function () {
        restoreFns.forEach(fn => fn());
        restoreFns.length = 0;
    };

    return tearDown;
};

export default onRouteChange;

